import { render } from "./PlatformDetails.vue?vue&type=template&id=6dc45662&scoped=true"
import script from "./PlatformDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDetails.vue?vue&type=script&setup=true&lang=js"

import "./PlatformDetails.vue?vue&type=style&index=0&id=6dc45662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc45662"],['__file',"src/components/PlatformDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dc45662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dc45662', __exports__)) {
    api.reload('6dc45662', __exports__)
  }
  
  module.hot.accept("./PlatformDetails.vue?vue&type=template&id=6dc45662&scoped=true", () => {
    api.rerender('6dc45662', render)
  })

}


export default __exports__